import { useState } from 'react';
import axios from 'axios';

export default function LandingPage() {
  const [nome, setNome] = useState('');
  const [cpf, setCpf] = useState('');
  const [ra, setRa] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [overlayMessage, setOverlayMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);

  const handleCPFChange = (e) => {
    let value = e.target.value.replace(/\D/g, '');
    if (value.length > 11) value = value.slice(0, 11);
    value = value.replace(/(\d{3})(\d)/, '$1.$2');
    value = value.replace(/(\d{3})(\d)/, '$1.$2');
    value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    setCpf(value);
  };

  const handleRAChange = (e) => {
    let value = e.target.value.replace(/\D/g, ''); // remove tudo que não for número
    if (value.length > 9) value = value.slice(0, 9); // máximo 9 dígitos

    if (value.length > 3) {
      value = value.replace(/(\d{3})(\d{0,6})/, '$1-$2');
    }

    setRa(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await axios.post('https://www.unipac.br/api-indicacao-premiada/inserir', {
        nome,
        cpf,
        ra
      });

      await new Promise(resolve => setTimeout(resolve, 5000));

      setOverlayMessage(response.data.mensagem || 'Cadastro realizado com sucesso!');
      setIsSuccess(true);
      setShowOverlay(true);

      setTimeout(() => {
        window.location.reload();
      }, 5000);

    } catch (error) {
      await new Promise(resolve => setTimeout(resolve, 5000));

      setOverlayMessage(error.response?.data?.erro || 'Erro ao enviar os dados.');
      setIsSuccess(false);
      setShowOverlay(true);

      setTimeout(() => {
        setShowOverlay(false);
        setOverlayMessage('');
        setIsSubmitting(false);
      }, 5000);
    }
  };

  return (
    <div className="relative flex flex-col md:flex-row items-start md:items-center justify-center md:h-screen bg-white">
      {/* Overlay de mensagem */}
      {showOverlay && (
        <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center">
          <div className="bg-white rounded-lg p-10 max-w-md w-11/12 text-center shadow-lg">
            <p className={`text-2xl font-bold ${isSuccess ? 'text-green-600' : 'text-red-600'}`}>
              {overlayMessage}
            </p>
          </div>
        </div>
      )}

      {/* Left Side - Text Section */}
      <div className="w-full h-full md:w-1/2 p-10 mb-10 md:mb-0">
        <h1 className="text-4xl text-center font-bold text-orange-600 mb-4">Indicação premiada</h1>

        <p className="text-justify mb-4 text-gray-700">
          Você, aluno FUPAC/UNIPAC, pode se cadastrar para indicar amigos para se matricularem no vestibular 2025/2.
          Cada amigo indicado que efetivar a matrícula garante a você 5% de desconto nas mensalidades!
        </p>

        <p className="text-1xl text-center font-bold text-orange-600 mb-4">
          Isso mesmo: indicou, matriculou, ganhou desconto!
        </p>

        <p className="mb-4 text-gray-700">
          Quanto mais amigos você indicar, maior será o seu benefício — podendo chegar a até 100% de desconto no semestre.
        </p>

        <p className="text-2xl font-bold text-orange-600 mb-4">👉 É simples participar:</p>

        <p className="mb-4 text-gray-700">Faça seu cadastro no Programa Indicação Premiada.</p>

        <p className="mb-4 text-gray-700">
          Compartilhe o link de inscrição com seus amigos - unipac.br/vestibular <br />
          <strong>Oriente seus amigos a informarem seu número de matrícula no momento da inscrição.</strong> <br />
          Assim, caso ele se matricule, você garante seu desconto.
        </p>


        <p className="mb-4 text-gray-700"><br /><br />Ficou alguma dúvida❓ WhatsApp (32) 3339-3986</p>

      </div>

      {/* Right Side - Form Section */}
      <div className="w-full h-full md:w-1/2 flex items-start justify-center relative overflow-hidden">
        <div className="w-full h-full bg-gradient-to-b from-blue-900 to-teal-600 shadow-lg text-white p-10">
          <h2 className="text-3xl text-center font-bold mb-2">FORMULÁRIO DE CADASTRO PARA O ALUNO INDICANTE</h2>





          <form className="space-y-4 text-center" onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Nome Completo"
              className="w-full p-2 rounded text-black"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              required
            />
            <input
              type="text"
              placeholder="CPF"
              className="w-full p-2 rounded text-black"
              value={cpf}
              onChange={handleCPFChange}
              required
            />
            <input
              type="text"
              placeholder="Número de matrícula (RA)"
              className="w-full p-2 rounded text-black"
              value={ra}
              onChange={handleRAChange}
              required
            />


            <p className="mb-6">
              Ao se inscrever, você concorda com os nossos{' '}
              <a
                href="https://unipac.br/wp-content/uploads/2025/06/ProgramaIndicacaoPremiada202502.pdf"
                className="text-white-900 underline hover:text-blue-800 transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                Termos e condições
              </a>.
            </p>


            <button
              type="submit"
              className="bg-green-500 hover:bg-green-600 text-white py-2 px-4 rounded disabled:opacity-50"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'ENVIANDO...' : 'ENVIAR'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
